



















import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/crm-contact';

@Component
export default class UiSelectContact extends BaseComponent {
  @Prop()
  value: any;

  @Prop()
  idsNotIn: Array<number>;

  @Prop()
  idInstitution: number;

  selected: any = null;

  loading = false;
  list = [];

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  @Watch('idsNotIn', { deep: true })
  onIdsNotInChange() {
    this.load();
  }

  @Watch('idInstitution')
  onIdInstitutionChange() {
    this.load();
  }

  mounted() {
    this.load();
  }

  load() {
    this.loading = true;
    service.listCrmContactsCombo(this.idsNotIn, this.idInstitution).subscribe(
      (res) => {
        this.list = res;
        this.loading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  onFilter(item, queryText, itemText) {
    let it =
      item.nome +
      (item.celular ? item.celular.replaceAll(/[^0-9]/g, '') : '') +
      (item.telefone ? item.telefone.replaceAll(/[^0-9]/g, '') : '') +
      (item.email ? item.email : '');
    let qt = queryText.replaceAll(/[^0-9a-zA-Z@]/g, '');
    return this.defaultCustomFilter(item, qt, it);
  }

  onChange() {
    this.$emit('input', this.selected);
  }
}
